import { render } from "./DocModal.vue?vue&type=template&id=bddfbf3c"
import script from "./DocModal.vue?vue&type=script&lang=js"
export * from "./DocModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__